
export default {
  loadGarage: { method: 'get', url: 'client/getGaragem/?client__id={id}' },
  getCredito: { method: 'post', url: 'client/creditClient/get_credito/' },
  GetColecoes: { method: 'get', url: 'product/colecoes//' },
}
